(function() {
  var ref;

  if ((ref = App.angularApp) != null) {
    ref.directive('mfHasOptions', [
      '$parse', function($parse) {
        return {
          require: 'ngModel',
          link: (function(_this) {
            return function(scope, element, attrs, ngModel) {
              var expr, getOptions;
              expr = attrs.ngOptions.replace(/^.*\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/, '$1');
              getOptions = $parse(expr);
              return ngModel.$validators.mfHasOptions = function(modelValue, viewValue) {
                var options;
                options = getOptions(scope);
                if ((options != null ? options.length : void 0) == null) {
                  return false;
                }
                return options.length > 0;
              };
            };
          })(this)
        };
      }
    ]);
  }

}).call(this);
